/*
 *
 * FormIndicator reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_SHOW_OTHER_INDICATOR_FAILED,
  GET_SHOW_OTHER_INDICATOR_SUCCESS,
  GET_SHOW_OTHER_INDICATOR_WATCHER,
  SET_UPDATE_OTHER_INDICATOR_FAILED,
  SET_UPDATE_OTHER_INDICATOR_SUCCESS,
  SET_UPDATE_OTHER_INDICATOR_WATCHER,
} from "./constants"

export const initialState = fromJS({
  isLoadingForm: true,
  form: {},
  isLoadingSave: false,
})

function formIndicatorReducer(state = initialState, action) {
  switch (action.type) {
    case GET_SHOW_OTHER_INDICATOR_WATCHER:
      return state.set("isLoadingForm", true).set("form", {})
    case GET_SHOW_OTHER_INDICATOR_SUCCESS:
      return state.set("isLoadingForm", false).set("form", action.payload)
    case GET_SHOW_OTHER_INDICATOR_FAILED:
      return state.set("isLoadingForm", false).set("form", {})

    case SET_UPDATE_OTHER_INDICATOR_WATCHER:
      return state.set("isLoadingSave", true)
    case SET_UPDATE_OTHER_INDICATOR_SUCCESS:
      return state.set("isLoadingSave", false)
    case SET_UPDATE_OTHER_INDICATOR_FAILED:
      return state.set("isLoadingSave", false)

    default:
      return state
  }
}

export default formIndicatorReducer
